import React from 'react';
import { ContactSegmentCounts, ContactSegment } from '../../types/contact';
import styles from './ContactSegments.module.css';

interface SegmentDefinition {
  key: ContactSegment;
  label: string;
  icon: string;
}

const SEGMENTS: SegmentDefinition[] = [
  { key: 'birthdaysThisMonth', label: 'Birthdays This Month', icon: '🎂' },
  { key: 'recentlyAdded', label: 'Recently Added', icon: '✨' },
  { key: 'recentlyUpdated', label: 'Recently Updated', icon: '🔄' },
  { key: 'incomplete', label: 'Incomplete', icon: '⚠️' },
];

interface ContactSegmentsProps {
  counts: ContactSegmentCounts | null;
  activeSegment: ContactSegment | null;
  onSegmentClick: (segment: ContactSegment) => void;
  compact?: boolean;
}

export const ContactSegments: React.FC<ContactSegmentsProps> = ({
  counts,
  activeSegment,
  onSegmentClick,
  compact = false,
}) => {
  if (!counts) return null;

  if (compact) {
    return (
      <div className={styles.pillsRow}>
        {SEGMENTS.map(seg => {
          const count = counts[seg.key];
          const isActive = activeSegment === seg.key;
          return (
            <button
              key={seg.key}
              className={`${styles.pill} ${isActive ? styles.active : ''}`}
              onClick={() => onSegmentClick(seg.key)}
              type="button"
            >
              {seg.icon} {seg.label}
              <span className={styles.pillCount}>({count})</span>
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div className={styles.segmentsGrid}>
      {SEGMENTS.map(seg => {
        const count = counts[seg.key];
        const isActive = activeSegment === seg.key;
        const isDisabled = count === 0;
        return (
          <div
            key={seg.key}
            className={`${styles.segmentCard} ${isActive ? styles.active : ''} ${isDisabled ? styles.disabled : ''}`}
            onClick={() => !isDisabled && onSegmentClick(seg.key)}
            role="button"
            tabIndex={isDisabled ? -1 : 0}
            onKeyDown={(e) => {
              if (!isDisabled && (e.key === 'Enter' || e.key === ' ')) {
                e.preventDefault();
                onSegmentClick(seg.key);
              }
            }}
          >
            <span className={styles.segmentIcon}>{seg.icon}</span>
            <span className={styles.segmentLabel}>{seg.label}</span>
            <span className={styles.segmentCount}>{count}</span>
          </div>
        );
      })}
    </div>
  );
};

export default ContactSegments;
